import { render, staticRenderFns } from "./ExcessOrder.vue?vue&type=template&id=287bcd66&"
import script from "./ExcessOrder.vue?vue&type=script&lang=js&"
export * from "./ExcessOrder.vue?vue&type=script&lang=js&"
import style0 from "./ExcessOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports